<div class="dropdown">
    <a href="javascript:void(0)" class="d-block text-gray-700 text-decoration-none dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
        <img src="{{ currentEntity.svg }}" alt="mdo" width="24" height="24" class="rounded-circle">
    </a>
    <ul class="dropdown-menu dropdown-menu-xl-end">
        <li><h6 class="dropdown-header">Entities</h6></li>
        <li *ngFor="let entity of entities">
            <a class="dropdown-item my-1" [ngClass]="{'active-entity': currentEntity.id === entity.id}" [class.pe-none]="currentEntity.id === entity.id" href="{{ baseUrl(entity.hostname) }}" target="_blank">
                <img [src]="entity.svg" alt="{{ entity.name }} icon" width="16" height="16" class="rounded-circle me-2" />
                {{ entity.name }}
            </a>
        </li>
    </ul>
</div>
